
import React, { useMemo, useState } from "react";
import "./ResearchFundingAgencies.css";
import Header from "../components/Header";
import Footer from "../components/Footer";

const agencies = [
  { name: "Aeronautics Research and Development Board (ARDB)", logo: "drdo.webp", url: "https://drdo.uat.dcservices.in/" },
  { name: "Atomic Energy Regulatory Board (AERB)", logo: "aerb.webp", url: "https://www.aerb.gov.in/english/" },
  { name: "Bhabha Atomic Research Centre (BARC)", logo: "barc.webp", url: "https://www.barc.gov.in/" },
  { name: "Centre for Development of Advanced Computing (CDAC)", logo: "cdac.webp", url: "https://www.cdac.in/" },
  { name: "Centre for Development of Telematics (C-DOT)", logo: "c-dot.webp", url: "http://www.cdot.com/" },
  { name: "Coal India Ltd.", logo: "coal-india.webp", url: "https://www.coalindia.in/" },
  { name: "Council of Scientific & Industrial Research (CSIR)", logo: "csir.webp", url: "https://www.csir.res.in/" },
  { name: "DBT-CTEP", logo: "dbt-ctep.webp", url: "https://www.dbtctep.gov.in/" },
  { name: "Defence Research & Development Organisation (DRDO)", logo: "drdo.webp", url: "http://www.drdo.nic.in/" },
  { name: "Department of Atomic Energy", logo: "atoms.webp", url: "https://dae.gov.in/" },
  { name: "Department of AYUSH", logo: "ayush-mission.webp", url: "https://ayush.gov.in/" },
  { name: "Department of Biotechnology (DBT)", logo: "dbt.webp", url: "https://dbt.gov.in/" },
  { name: "Department of Chemicals & Petrochemicals, Ministry of Chemicals & Fertilizers", logo: "dept-chemical-petro-chemical.webp", url: "https://chemicals.gov.in/" },
  { name: "Department of Fertilizers, Ministry of Chemicals & Fertilizers", logo: "dept-of-fertilizers.webp", url: "https://fert.gov.in/en" },
  { name: "Department of Ocean Development", logo: "dept-ocean-development.webp", url: "https://www.moes.gov.in/" },
  { name: "Department of Science & Technology (DST)", logo: "dst.webp", url: "https://dst.gov.in/" },
  { name: "Deutsche Forschungsgemeinschaft (DFG – German Research Foundation)", logo: "dfg.webp", url: "https://www.dfg.de/en/" },
  { name: "GAIL (India) Ltd.", logo: "gail.webp", url: "https://www.gailonline.com/" },
  { name: "India Science, Technology and Innovation", logo: "science-technology.webp", url: "https://www.indiascienceandtechnology.gov.in/funding-opportunities/grants-for-conference-seminars/ugc-travel-grant-scheme" },
  { name: "Indian Council of Agricultural Research (ICAR)", logo: "icar.webp", url: "https://www.icar.org.in/" },
  { name: "Indian Council of Medical Research (ICMR)", logo: "icmr.webp", url: "https://www.icmr.gov.in/" },
  { name: "Indian Council of Social Science Research (ICSSR)", logo: "icssr.webp", url: "https://www.icssr.org/" },
  { name: "Indian National Science Academy (INSA)", logo: "insa.webp", url: "https://insaindia.res.in/" },
  { name: "Indian Space Research Organisation (ISRO)", logo: "isro.webp", url: "https://www.isro.gov.in/" },
  { name: "Indo French Centre for the Promotion of Advanced Research (IFCPAR)", logo: "ifcpar.webp", url: "https://www.cefipra.org/" },
  { name: "Indo-US Science & Technology Forum", logo: "indo-us-science-tech.webp", url: "https://iusstf.org/" },
  { name: "Ministry of Agro & Rural Industries", logo: "agro-rural-industry.webp", url: "https://agriwelfare.gov.in" },
  { name: "Ministry of Communications & Information Technology", logo: "communication-info-tech.webp", url: "https://www.dot.gov.in/" },
  { name: "Ministry of Defence", logo: "defence.webp", url: "https://www.mod.gov.in/" },
  { name: "Ministry of Environment & Forests (MoEF)", logo: "moef.webp", url: "https://moef.gov.in/" },
  { name: "Ministry of Health & Family Welfare", logo: "health-family-welfare.webp", url: "https://www.mohfw.gov.in/" },
  { name: "Ministry of Micro, Small and Medium Enterprises", logo: "micro-small-medium-enterprise.webp", url: "https://msme.gov.in/" },
  { name: "Ministry of New and Renewable Energy (MNRE)", logo: "mnre.webp", url: "https://mnre.gov.in/" },
  { name: "Ministry of Petroleum & Natural Gas", logo: "petroleum-natural-gas.webp", url: "https://mowebp.gov.in/en" },
  { name: "Ministry of Power", logo: "mop.webp", url: "https://www.powermin.gov.in/" },
  { name: "Ministry of Road Transport & Highways", logo: "road-transport-highway.webp", url: "https://morth.nic.in/" },
  { name: "Ministry of Rural Development", logo: "rural-development.webp", url: "https://www.rural.gov.in/" },
  { name: "Ministry of Textiles", logo: "textiles.webp", url: "https://www.texmin.gov.in/" },
  { name: "Ministry of Urban Development", logo: "urban-development.webp", url: "https://www.mohua.gov.in/" },
  { name: "Ministry of Water Resources", logo: "water-resources.webp", url: "https://www.jalshakti-dowr.gov.in/" },
  { name: "National Science Foundation", logo: "nsf.webp", url: "https://www.nsf.gov/" },
  { name: "Naval Research Board (NRB)", logo: "nrb.webp", url: "https://drdo.uat.dcservices.in/" },
  { name: "Northern Indian Textile Research Association (NITRA)", logo: "nitra.webp", url: "https://nitratextile.org/" },
  { name: "Oil & Natural Gas Corporation Ltd (ONGC)", logo: "ongc.webp", url: "https://ongcindia.com/" },
  { name: "Petroleum Conservation Research Association (PCRA)", logo: "pcra.webp", url: "https://www.indiascienceandtechnology.gov.in/" },
  { name: "Science and Engineering Research Board (SERB)", logo: "serb.webp", url: "https://www.indiascienceandtechnology.gov.in/" },
  { name: "Tata Institute of Fundamental Research", logo: "tifr.webp", url: "https://www.tifr.res.in/" },
  { name: "Technology Information, Forecasting & Assessment Council (TIFAC)", logo: "tifac.webp", url: "https://www.dst.gov.in/" },
  { name: "UK India Education and Research Initiative (UKIERI)", logo: "ukieri.webp", url: "https://www.britishcouncil.in/" },
  { name: "University Grants Commission", logo: "ugc.webp", url: "https://www.ugc.gov.in/" },
  { name: "University Grants Commission", logo: "ugcl.webp", url: "https://www.ugc.gov.in/oldpdf/xiplanpdf/travelgrant" }
];

const ITEMS_PER_PAGE = 12;

const ResearchFundingAgencies = () => {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const filteredAgencies = useMemo(() => {
    return agencies.filter((agency) =>
      agency.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [search]);

  const totalPages = Math.ceil(filteredAgencies.length / ITEMS_PER_PAGE);

  const currentAgencies = filteredAgencies.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const changeSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  return (
    <>
     <Header />
      <section className="relative w-full h-[200px] md:h-[240px] overflow-hidden">

        <img
          src="/images/campusKumaun.avif"
          alt="Kumaun University"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 md:px-10 flex items-center">
          <div>
            <div className="flex flex-wrap items-center gap-2 text-sm md:text-base text-[#123B5D]  font-gill mb-5 font-gill">
              <span className="text-[#123B5D] text-lg font-gill">Home</span>
              <span className="text-[#123B5D] text-lg font-gill">/</span>
              <span className="font-semibold text-[#123B5D] text-lg font-gill">
                Research Funding Agencies
              </span>
            </div>

            <div className="w-16 h-1 bg-[#B5121B] mb-5 rounded-full" />

            <h1 className="text-3xl md:text-5xl font-bold text-[#064E3B] tracking-wide">
             RESEARCH FUNDING AGENCIES
            </h1>

          
          </div>
        </div>
      </section>
    <section className="rfa-section">
  <div className="rfa-container">

    {/* Search */}
    <div className="rfa-search">
      <input
        type="text"
        placeholder="Search here"
        value={search}
        onChange={changeSearch}
      />
    </div>

    {/* Agency Cards */}
    <div className="rfa-grid">
      {currentAgencies.map((agency, index) => (
        <div className="rfa-card" key={`${agency.logo}-${index}`}>

          <div className="rfa-image">
            <img
              src={`/research_image/${agency.logo}`}
              alt={agency.name}
              loading="lazy"
            />
          </div>

          <div className="rfa-content">
            <h3>{agency.name}</h3>

            <a
              href={agency.url}
              target="_blank"
              rel="noopener noreferrer"
              className="rfa-visit"
            >
              <i className="fa-solid fa-arrow-up-right-from-square"></i>
              Visit
            </a>
          </div>

        </div>
      ))}
    </div>

    {/* No Result */}
    {filteredAgencies.length === 0 && (
      <div className="rfa-no-result">
        No research funding agency found.
      </div>
    )}

    {/* Pagination */}
    {totalPages > 1 && (
      <div className="rfa-pagination">

        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
        >
          <i className="fa-solid fa-angle-left"></i>
        </button>

        {Array.from({ length: totalPages }, (_, i) => i + 1).map(
          (page) => (
            <button
              key={page}
              className={currentPage === page ? "active" : ""}
              onClick={() => setCurrentPage(page)}
            >
              {page}
            </button>
          )
        )}

        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(currentPage + 1)}
        >
          <i className="fa-solid fa-angle-right"></i>
        </button>

      </div>
    )}

  </div>
</section>
     <Footer />
    </>
  );
};

export default ResearchFundingAgencies;
